import { QuestionCardSkeleton } from "./QuestionCardSkeleton";

interface QuestionsSkeletonContainerProps {
  countMultipleChoice: number;
  countFreeText: number;
  isEditPage?: boolean;
}

export function QuestionsSkeletonContainer({
  countMultipleChoice,
  countFreeText,
  isEditPage = false,
}: QuestionsSkeletonContainerProps) {
  const totalQuestions = countMultipleChoice + countFreeText;

  return (
    <>
      {Array.from({ length: totalQuestions }, (v, index) => (
        <QuestionCardSkeleton
          isEditPage={isEditPage}
          index={index}
          key={`skeleton-container-${v}`}
        />
      ))}
    </>
  );
}
